<div class="operation-content">
  <div class="operation-controls">
    <y42-operation-input-operator-form-control
      [operatorControl]="form.controls.operator!"
      [operatorOptions]="state.operatorOptions"
    ></y42-operation-input-operator-form-control>

    <div
      *ngIf="
        form.controls.operator?.value !== OperatorEnum.In &&
        form.controls.operator?.value !== OperatorEnum.NotIn &&
        form.controls.operator?.value !== OperatorEnum.IsEmpty &&
        form.controls.operator?.value !== OperatorEnum.IsNotEmpty
      "
    >
      <mat-form-field [style.fontSize]="'10px'" appearance="outline" class="w-full no-padding">
        <mat-label>{{ form.controls.operator?.value === OperatorEnum.Between ? 'From' : 'Number' }} </mat-label>
        <input
          matInput
          type="number"
          autocomplete="off"
          [ngModel]="form.controls.values.value[0]"
          (ngModelChange)="patchValues($event, 0)"
        />
      </mat-form-field>
    </div>
    <div
      *ngIf="form.controls.operator?.value === OperatorEnum.In || form.controls.operator?.value === OperatorEnum.NotIn"
    >
      <y42-operation-input-chip-list #operationInputChipList [valuesControl]="form.controls.values" [index]="index">
        <input
          *ngIf="operationInputChipList.chipList"
          type="number"
          [matChipInputFor]="operationInputChipList.chipList"
          [matChipInputSeparatorKeyCodes]="operationInputChipList.separatorKeysCodes"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="
            operationInputChipList.addChip(form.controls.operator!.value!, $event.value, $event.input)
          "
        />
        <mat-hint> Click 'Enter' to select</mat-hint>
      </y42-operation-input-chip-list>
    </div>
    <div *ngIf="form.controls.operator?.value === OperatorEnum.Between">
      <mat-form-field [style.fontSize]="'10px'" appearance="outline" class="w-full no-padding">
        <mat-label>To</mat-label>
        <input
          matInput
          [ngModel]="form.controls.values.value[1]"
          (ngModelChange)="patchValues($event, 1)"
          autocomplete="off"
          type="number"
        />
      </mat-form-field>
    </div>
  </div>

  <y42-operation-input-delete [index]="index" [columnType]="columnType"></y42-operation-input-delete>
</div>

<y42-operation-input-add
  [index]="index"
  [columnType]="columnType"
  [defaultOperator]="state.operatorOptions[0].value"
  [enableMoreConditions]="enableMoreConditions"
></y42-operation-input-add>
